export const monthYearText = ({ month, year }) => {
  const d = new Date(year, month - 1, 1)
  const mon = d.toLocaleString("en-US", { month: "short" }).toUpperCase()
  return `${mon} ${year}`
}

export const formatMonYear = (month, year) => {
  return monthYearText({ month, year })
}

export const parseDateToMonthYear = (dateStr) => {
  const d = new Date(dateStr)
  return { month: d.getMonth() + 1, year: d.getFullYear() }
}

export const addDays = (date, days) => {
  const next = new Date(date)
  next.setDate(next.getDate() + days)
  return next
}

export const toISODate = (date) => {
  return date.toISOString().slice(0, 10)
}

export const monthRange = (date) => {
  const first = new Date(date.getFullYear(), date.getMonth(), 1)
  const last = new Date(date.getFullYear(), date.getMonth() + 1, 0)
  return [first, last]
}

export const yearRange = (date) => {
  const first = new Date(date.getFullYear(), 0, 1)
  const last = new Date(date.getFullYear(), 11, 31)
  return [first, last]
}

export const startOfWeekMonday = (date) => {
  const next = new Date(date.getFullYear(), date.getMonth(), date.getDate())
  const day = next.getDay()
  const diff = (day === 0 ? -6 : 1) - day
  next.setDate(next.getDate() + diff)
  next.setHours(0, 0, 0, 0)
  return next
}

export const startOfWeekSunday = (date) => {
  const next = new Date(date.getFullYear(), date.getMonth(), date.getDate())
  const day = next.getDay()
  next.setDate(next.getDate() - day)
  next.setHours(0, 0, 0, 0)
  return next
}

export const isoWeekNumber = (date) => {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
  const day = d.getUTCDay() || 7
  d.setUTCDate(d.getUTCDate() + 4 - day)
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
  const diff = (d.getTime() - yearStart.getTime()) / 86400000
  return Math.floor(diff / 7) + 1
}
